import React, { useState } from "react";
import "./ApplyJob.css";
import FilterJob from "./FilterJob/FilterJob";
import JobCards from "./JobCards/JobCards";
import { useLocation, useParams } from "react-router-dom";
export default function ApplyJob() {
  const [isFilterShow, setIsFilterShow] = useState(false);
  // const params = useParams();
  const location = useLocation();
  console.log(location);
  const params = new URLSearchParams(location.search);
  const locationParam = params.get("location");
  console.log(locationParam, "ssss");
  const handleSetFilter = (data) => {
    setIsFilterShow(data);
  };
  return (
    <div className="applyJob-main d-flex align-items-start justify-content-between gap-1 w-100">
      <div
        className={`left-job-section responsiveFilterBox px-1 py-1 ${
          isFilterShow && "d-block"
        }`}
      >
        <FilterJob
          isFilterShow={isFilterShow}
          handleSetFilter={handleSetFilter}
        />
      </div>
      <div className="job-card-component flex-grow-1">
        <JobCards handleSetFilter={handleSetFilter} />
      </div>
    </div>
  );
}
